import { useQuery } from '@tanstack/react-query'

import { fetchParkingBySlug } from '@/utils/parkingsService'

import { ApiPaths } from '@/utils/apiPaths'

import { ParkingsBySlugParams } from '../parkings'

export const useFetchParkingBySlug = ({
  slug,
  params,
  enabled = true
}: {
  slug: string
  params: ParkingsBySlugParams
  enabled?: boolean
}) => {
  const { data, isLoading } = useQuery({
    queryKey: [`${ApiPaths.API_V1_PARKINGS}/${slug}`, params],
    queryFn: () => fetchParkingBySlug({ slug, params }),
    enabled: enabled && Boolean(slug)
  })
  return {
    parking: data?.parking,
    details: data?.details,
    isLoading
  }
}
